import { render, staticRenderFns } from "./VSidebar.vue?vue&type=template&id=65c0a842&scoped=true&"
import script from "./VSidebar.vue?vue&type=script&lang=js&"
export * from "./VSidebar.vue?vue&type=script&lang=js&"
import style0 from "./VSidebar.vue?vue&type=style&index=0&id=65c0a842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c0a842",
  null
  
)

export default component.exports